import React from "react"

import { reportListData } from "../../../../@signals"
import ReportListHistoricalModalContent from "./Content"


export default function ReportListHistoricalModal({ idReport }) {

	const [data] = reportListData.value.filter(a => a.idReport === idReport)

	return <ReportListHistoricalModalContent
		id_report={idReport}
		rowData={data}
	/>
}